var _path, _path2, _path3, _path4;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgHam = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M10.8334 31.6667C15.896 31.6667 20.0001 26.0702 20.0001 19.1667C20.0001 12.2631 15.896 6.66669 10.8334 6.66669C5.7708 6.66669 1.66675 12.2631 1.66675 19.1667C1.66675 26.0702 5.7708 31.6667 10.8334 31.6667Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8334 26.6667C13.1346 26.6667 15.0001 23.3088 15.0001 19.1667C15.0001 15.0246 13.1346 11.6667 10.8334 11.6667C8.53223 11.6667 6.66675 15.0246 6.66675 19.1667C6.66675 23.3088 8.53223 26.6667 10.8334 26.6667Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2134 14.41L15.895 8.26334C15.1834 7.83834 14.4267 7.53167 13.6567 7.27667C17.3367 8.90167 20 13.6083 20 19.1667C20 25.555 16.4834 30.815 11.9467 31.565H11.9434C13.3734 31.47 14.7984 31.3033 16.2017 30.9817L24.2267 29.1433C27.5917 28.3733 30 25.1317 30 21.3767C30 18.4733 28.5484 15.8017 26.2134 14.41Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M37.1834 22.5C38.0501 21.7416 38.5351 20.5583 38.2517 19.2616C37.9784 18.0083 36.9317 16.98 35.6717 16.7333C34.3117 16.4683 33.0601 17.03 32.3284 18.005C31.4484 19.1816 30.1751 20 28.7051 20H26.6667V25H28.7051C30.1751 25 31.4484 25.8183 32.3284 26.995C33.0584 27.97 34.3117 28.5333 35.6717 28.2666C36.9317 28.02 37.9784 26.9916 38.2517 25.7383C38.5351 24.4416 38.0501 23.2583 37.1834 22.5Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgHam, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ham.79b9e0d9.svg";
export { ForwardRef as ReactComponent };